import { render, staticRenderFns } from "./editModeCoordinate.vue?vue&type=template&id=1956453b&scoped=true&"
import script from "./editModeCoordinate.vue?vue&type=script&lang=js&"
export * from "./editModeCoordinate.vue?vue&type=script&lang=js&"
import style0 from "./editModeCoordinate.vue?vue&type=style&index=0&id=1956453b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956453b",
  null
  
)

export default component.exports